module.exports = __webpack_public_path__ + "img/logo.3d6bf631.png";